import React from 'react';
import { withStyles } from '@mui/styles';

const styles = {
  loader: {
    width: '20px',
    height: '14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  col: {
    width: '3px',
    height: '100%',
    marginRight: '3px',
    backgroundColor: '#333',
    animation: '$spinner 0.8s infinite ease-in-out',
  },
  col1: { animationDelay: '-1.1s' },
  col2: { animationDelay: '-1.0s' },
  col3: { animationDelay: '-0.9s' },
  '@keyframes spinner': {
    '0%': {
      transform: 'scaleY(0.4)',
    },
    '20%': {
      transform: 'scaleY(0.8)',
    },
    '40%': {
      transform: 'scaleY(0.4)',
    },
    '100%': {
      transform: 'scaleY(0.4)',
    },
  },
};
export default withStyles(styles)(({ className, classes, style, color }) => (
  <div className={`${classes.loader} ${className}`} style={style}>
    <div
      style={{
        backgroundColor: `${color || ''}`,
      }}
      className={`loader=col ${classes.col} ${classes.col1}`}
    />
    <div
      style={{
        backgroundColor: `${color || ''}`,
      }}
      className={`loader=col ${classes.col} ${classes.col2}`}
    />
    <div
      style={{
        backgroundColor: `${color || ''}`,
      }}
      className={`loader=col ${classes.col} ${classes.col3}`}
    />
  </div>
));
